import { render, staticRenderFns } from "./OnlineDeclarationPage.vue?vue&type=template&id=48be56f6&scoped=true&"
import script from "./OnlineDeclarationPage.vue?vue&type=script&lang=js&"
export * from "./OnlineDeclarationPage.vue?vue&type=script&lang=js&"
import style0 from "./OnlineDeclarationPage.vue?vue&type=style&index=0&id=48be56f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be56f6",
  null
  
)

export default component.exports